import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { IDespacho, IFilter, IPopulate, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';
import { DespachosService } from '../../../despachos/despachos.service';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../../../auxiliares/dialog/dialog.service';
import { FormularioDialogService } from '../../../../../../auxiliares/servicios/formulario-dialog.service';
import { EditarDespachoComponent } from '../../editar-despacho/editar-despacho.component';
import { TZDate } from '@date-fns/tz';
import { CrearEditarDespachoComponent } from '../../crear-editar-despacho/crear-editar-despacho.component';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';

@Component({
  selector: 'app-listado',
  templateUrl: './listado.component.html',
  styleUrl: './listado.component.scss',
  standalone: false,
})
export class ListadoComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(DespachosService);

  private formularios = inject(FormularioDialogService);
  private hoy = new Date();
  //// Tabla nueva
  public name = 'ListadoDespachosComponent';
  public totalCount = 0;
  public columnas?: IColumnas<IDespacho>[];
  public despachos?: IDespacho[];
  //

  //Subs
  private despachos$?: Subscription;

  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Colectivos - Crear cronogramas'),
    tooltip: 'Crear despacho',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };

  public search: IRegExpSearch = {
    fields: ['nombre'],
  };

  public filter: IFilter<IDespacho> = {};
  public populate: IPopulate[] = [
    {
      path: 'usuario',
      select: 'usuario datosPersonales',
    },
    {
      path: 'activo',
      select: 'vehiculo identificacion',
    },
    {
      path: 'chofer',
      select: 'datosPersonales',
    },
    {
      path: 'recorridos',
      select: 'nombre',
    },
    {
      path: 'cronograma',
      select: 'nombre',
    },
  ];
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public activo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idActivo',
    },
    label: 'Activo',
    selectLabel: 'identificacion',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'activos',
    searchOn: ['identificacion'],
  };
  public chofer: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idChofer',
    },
    label: 'Chofer',
    selectLabel: 'usuario',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'usuarios',
    searchOn: ['usuario'],
  };
  public cronograma: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idCronograma',
    },
    label: 'Cronograma',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'cronogramas',
    searchOn: ['nombre'],
  };
  public recorrido: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idsRecorridos',
    },
    label: 'Recorrido',
    selectLabel: 'nombre',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'recorridos',
    searchOn: ['nombre'],
  };
  public usuario: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'idUsuario',
    },
    label: 'Usuario',
    selectLabel: 'usuario',
    selectValue: '_id',
    tipo: 'ngselect-async',
    asyncFunction: 'usuarios',
    searchOn: ['usuario'],
  };
  public filtros: IFiltroTabla[] = [
    this.activo,
    this.chofer,
    this.cronograma,
    this.recorrido,
    this.usuario,
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };
  // Listars

  public async listar(): Promise<void> {
    this.despachos$?.unsubscribe();
    this.despachos$ = this.lista2
      .despachos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.despachos = data.datos;
      });
  }

  // Acciones
  public async editar(despacho: IDespacho) {
    this.formularios.abrir(EditarDespachoComponent, {
      tamano: 'mediano',
      data: despacho._id,
    });
  }

  public async eliminar(despacho: IDespacho) {
    const res = await this.dialogService.confirm(
      'Eliminar despacho',
      `¿Querés eliminar el despacho del ${this.fechaVisible(despacho.fecha)}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(despacho._id!);
      this.helper.notifSuccess('Despacho eliminado');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public crear() {
    const res = this.formularios.abrir(CrearEditarDespachoComponent, {
      tamano: 'mediano',
    });
    if (res) {
      res.afterClosed().subscribe(() => {
        this.listar();
      });
    }
  }

  public async cancelarDespacho(despacho: IDespacho) {
    const res = await this.dialogService.confirm(
      'Cancelar despacho',
      `¿Querés cancelar el despacho del ${this.fechaVisible(despacho.fecha)}?`,
    );
    if (!res) return;
    try {
      await this.service.cancelar(despacho._id);
      this.helper.notifSuccess('Despacho cancelado');
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  public async reactivarDespacho(despacho: IDespacho) {
    const res = await this.dialogService.confirm(
      'Reactivar despacho',
      `¿Querés reactivar el despacho del ${this.fechaVisible(despacho.fecha)}?`,
    );
    if (!res) return;
    try {
      await this.service.reactivar(despacho._id);
      this.helper.notifSuccess('Despacho reactivado');
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Completado',
        },
        row: {
          // Cancelado manda; si no, Pendiente hasta la hora de salida y
          // Completado después (mismo cálculo de siempre).
          estado: (dato) => {
            if (dato.cancelado) {
              return { texto: 'Cancelado', tono: 'neutro', icono: 'block' };
            }
            const hoyArg = new TZDate(
              new Date(),
              'America/Argentina/Buenos_Aires',
            );
            const hhMM = dato.hora.split(':');
            const fecha = new TZDate(
              dato.fecha,
              'America/Argentina/Buenos_Aires',
            );
            fecha.setHours(+hhMM[0], +hhMM[1]);
            return fecha.getTime() > hoyArg.getTime()
              ? { texto: 'Pendiente', tono: 'info', icono: 'pending' }
              : { texto: 'Completado', tono: 'ok', icono: 'check_circle' };
          },
        },
      },
      {
        header: {
          label: 'Día',
          sortable: true,
          sort: 'fecha',
        },
        row: {
          parse: (dato) => this.fechaVisible(dato.fecha),
          noData: 'Sin fecha',
        },
      },
      {
        header: {
          label: 'Sale',
          sortable: true,
        },
        row: {
          field: 'hora',
          noData: 'Sin hora',
        },
      },
      {
        header: {
          label: 'Salió',
          sortable: true,
        },
        row: {
          field: 'salio',
          noData: 'Sin salida',
        },
      },
      {
        header: {
          label: 'Cronograma',
        },
        row: {
          parse: (dato) => dato.cronograma?.nombre,
          noData: 'Sin cronograma',
        },
      },
      {
        header: {
          label: 'Coche',
        },
        row: {
          parse: (dato) => {
            const partes = [
              dato.activo?.identificacion,
              dato.activo?.vehiculo?.patente,
            ].filter(Boolean);
            return partes.length ? partes.join(' - ') : undefined;
          },
          noData: 'Sin coche',
        },
      },
      {
        header: {
          label: 'Chofer',
        },
        row: {
          parse: (dato) => this.parseChofer(dato),
          noData: 'Sin chofer',
        },
      },
      {
        header: {
          label: 'Recorridos',
        },
        row: {
          parse: (dato) => this.parseRecorridos(dato),
          noData: 'Sin recorridos',
        },
      },
      {
        header: {
          label: 'Usuario',
        },
        row: {
          // Sin usuario el despacho lo creó el sistema: es un valor real.
          parse(dato) {
            return (
              dato.usuario?.datosPersonales?.nombre ||
              dato.usuario?.usuario ||
              'Despacho automático'
            );
          },
        },
      },
      {
        header: {
          label: 'Acciones',
        },
        row: {
          // Editar · Cancelar o Reactivar (una sola a la vez) · Eliminar
          acciones: [
            {
              tipo: 'material',
              color: 'primary',
              icon: 'edit',
              tooltip: 'Editar',
              click: (dato) => this.editar(dato),
              disabled: (dato) =>
                !this.helper.tienePermiso('Colectivos - Editar cronogramas') &&
                this.checkFecha(dato),
            },
            {
              tipo: 'material',
              color: 'primary',
              icon: 'close',
              tooltip: 'Cancelar despacho',
              click: (dato) => this.cancelarDespacho(dato),
              disabled: (dato) =>
                !this.helper.tienePermiso('Colectivos - Editar cronogramas') &&
                (this.checkFecha(dato) || dato.cancelado),
              oculta: (dato) => dato.cancelado,
            },
            {
              tipo: 'material',
              color: 'primary',
              icon: 'toggle_on',
              tooltip: 'Reactivar despacho',
              click: (dato) => this.reactivarDespacho(dato),
              disabled: (dato) =>
                !this.helper.tienePermiso('Colectivos - Editar cronogramas') &&
                (this.checkFecha(dato) || !dato.cancelado),
              oculta: (dato) => !dato.cancelado,
            },
            {
              tipo: 'material',
              color: 'warn',
              icon: 'delete',
              tooltip: 'Eliminar',
              click: (dato) => this.eliminar(dato),
              disabled: (dato) =>
                !this.helper.tienePermiso(
                  'Colectivos - Eliminar cronogramas',
                ) && this.checkFecha(dato),
            },
          ],
        },
      },
    ];
  }
  ///

  private parseChofer(dato: IDespacho) {
    if (dato.chofer?.identificacionInterna) {
      return dato.chofer?.identificacionInterna;
    } else {
      return dato.chofer?.datosPersonales?.nombre || dato.chofer?.usuario;
    }
  }

  private parseRecorridos(dato: IDespacho) {
    const nombres = (dato.recorridos ?? []).map((r) => r.nombre);
    return nombres.join(', ');
  }

  public checkFecha(d: IDespacho) {
    const hoyArg = new TZDate(this.hoy, 'America/Argentina/Buenos_Aires');
    const fecha = new TZDate(this.hoy, 'America/Argentina/Buenos_Aires');
    const horaYMinutos = d.hora.split(':');
    const anioMesDia = d.fecha.split('-');
    fecha.setFullYear(+anioMesDia[0], +anioMesDia[1] - 1, +anioMesDia[2]);
    fecha.setHours(+horaYMinutos[0], +horaYMinutos[1]);
    // True si la fecha es anterior a la actual por media hora
    const limite = 1000 * 60 * 60; // 1 hora
    return fecha.getTime() < hoyArg.getTime() - limite;
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.despachos$?.unsubscribe();
  }

  /** 'yyyy-MM-dd' (como lo guarda el backend) → 'dd/MM/yyyy'. */
  private fechaVisible(fecha?: string): string | undefined {
    if (!fecha) return undefined;
    const [anio, mes, dia] = fecha.split('-');
    return dia && mes && anio ? `${dia}/${mes}/${anio}` : fecha;
  }
}
